
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styled from '@emotion/styled';
import Item, { ItemUl, ItemText } from 'library/molecules/Item';
import { H4, Text } from 'library/atoms/Typography';
import { useRouter } from 'next/router';
import Layout from 'library/atoms/Layout';
import useTranslation from 'next-translate/useTranslation';
import widgetRoutes from 'enums/routes';
import { MembershipPresenter, OutletPresenter } from 'shared/presenters';
import Header from 'library/molecules/Header';
import Breadcrumb from 'library/molecules/Breadcrumb';
import { MEMBERSHIPS_IMAGE_URL, MEMBERSHIPS_TITLE } from 'enums/memberships';
import CoverImage from 'library/atoms/CoverImage';
import { defined, definedNotNull } from 'shared/presenters/presenter';
import determineMembershipImage from 'helpers/determineMembershipImage';
import { StyledLink, StyledTagsList } from 'library/molecules/SchedulableCard';
import HeadContainer from 'library/atoms/HeadContainer';
export interface MembershipsProps {
    memberships: MembershipPresenter[];
    outlet: OutletPresenter;
}
const Memberships = ({ memberships: membershipsJSON, outlet: outlet }: MembershipsProps) => {
    const { query } = useRouter();
    const widgetSlug = query.widgetSlug as string;
    const { t } = useTranslation('chargeable');
    const memberships = membershipsJSON?.map(membership => new MembershipPresenter(membership));
    const pageTitle = MEMBERSHIPS_TITLE;
    const breadcrumbs = [
        {
            link: widgetRoutes.HOME.url({ widgetSlug: widgetSlug }),
            name: definedNotNull(outlet.name),
            image: ''
        },
        {
            link: widgetRoutes.MEMBERSHIPS.url({ widgetSlug }),
            name: pageTitle,
            image: MEMBERSHIPS_IMAGE_URL,
            currentPage: true
        }
    ];
    return (<>
      <HeadContainer title={t('memberships-page-title', { outlet: outlet.name })} description={t('memberships-page-description', { outlet: outlet.name })}>
        {!outlet.feature_toggles?.marketplace_enabled ||
            (outlet.admin_forced_marketplace_disable && (<meta name="robots" content="noindex"/>))}
      </HeadContainer>
      <Layout>
        <Header />
        <Breadcrumb pages={breadcrumbs} firstLinkAsHome={true}/>
        <main>
          <ItemUl>
            {memberships?.map(membership => (<StyledLink key={membership.id} href={widgetRoutes.MEMBERSHIP.url({
                widgetSlug,
                membershipSlug: defined(membership.id)
            })} passHref>
                <Item variant="card" title={t('common:view-item-name', {
                itemName: membership.name()
            })}>
                  <CoverImage height={250} src={determineMembershipImage({ outlet, membership })}/>
                  <ItemText>
                    <H4>{membership.name()}</H4>
                  </ItemText>
                  <ItemText>
                    <StyledTagsList>
                      <Text size="sm" fontstyle="p3" color="secondary">
                        {t('common:membership')}
                      </Text>
                    </StyledTagsList>
                  </ItemText>
                  <ItemText>
                    {membership.description() && (<StyledText color="secondary">
                        {membership.description()}
                      </StyledText>)}
                  </ItemText>
                </Item>
              </StyledLink>))}
          </ItemUl>
        </main>
      </Layout>
    </>);
};
export default Memberships;
const StyledText = styled(Text)(({ theme }) => ({
    ...theme.mixins.ellipsisLineClamp(3),
    whiteSpace: 'pre-line'
}));

    async function __Next_Translate__getStaticProps__197e9a555ba__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Memberships/Memberships',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197e9a555ba__ as getStaticProps }
  